var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-btn"},[_c('GAction',{attrs:{"content":{
      label: _vm.content.label,
      url: _vm.content.url,
      target: _vm.content.target,
      icon: 'arrow',
      modifiers: ['global', 'long'],
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }